module.exports = __webpack_public_path__ + "img/sld_scb_8_t1_green.d5541a25.svg";